<accordion [isAnimated]="true">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-money-bill'></i> Método de Devolución
    </span>
    <div class="form-group row">
      <div class="col-md-6">
        <!-- <button type="button" (click)="cancel()" [disabled]="validateCanceled()"
                  class="btn btn-sm btn-success"><i class="fa fa-times"></i>&nbsp;Cancelar</button> -->
        <button type="button" class="btn btn-lg btn-outline-primary mr-2" (click)="return(paymentTypes.CASH)"
          *ngIf="!hideCashButton"><i class="fa fa-money-bill"></i>&nbsp;Efectivo</button>
        <button type="button" class="btn btn-lg btn-outline-primary" (click)="return(paymentTypes.CREDIT_NOTE)"><i
            class="fa fa-regular fa-file-lines"></i>&nbsp;Nota de Crédito</button>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label"><b>Total a devolver</b></label>
      <div class="col-md-9">
        <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="order.totals.netTotal"
          prefix="HNL " mask="separator.2" thousandSeparator="," readonly>
      </div>
    </div>

  </accordion-group>
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-cart-shopping'></i> Orden
    </span>
    <pos-totals [totals]="order.totals"></pos-totals>
    <div class="row">
      <div class="col-12">
        <pos-table tableFormId="productsCartTable" [data]="productsCart" [headers]="getProductCartHeaders()"
          [filters]="[]" [itemsPerPage]="10" [pagination]="false" [disableHighlight]="true">
        </pos-table>
      </div>
    </div>
  </accordion-group>
</accordion>